module.exports = __webpack_public_path__ + "img/spinner.e4347ffe.svg";